import React, { useContext } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames/bind';
import {
  Button,
  Card,
  CardContent,
  CardTitle,
  Image,
  Placeholder
} from '@thd-olt-component-react/core-ui';
import { StoreHeroContext } from '../../StoreHero.context';
import styles from './store-hero-curbside.module.scss';

const cx = classNames.bind(styles);

const StoreHeroCurbside = ({ className }) => {
  const { loading, store } = useContext(StoreHeroContext);
  const { flags, storeId } = store || {};
  const { curbsidePickupFlag } = flags || {};

  const redirectUser = ({ href }) => {
    window.location.href = href;
  };

  const curbsideClasses = cx('store-hero-curbside', className, {
    'store-hero-curbside--loading': loading
  });

  if (loading) {
    return (
      <Card className={curbsideClasses} sharp>
        <CardContent className={cx('store-hero-curbside__loader-wrapper')}>
          {new Array(2).fill('').map((value, i) => (
            <Placeholder key={`${value}-${i}`} type="text" />
          ))}
          <Placeholder type="round" className={cx('store-hero-curbside__loader-circle')} />
          {new Array(2).fill('').map((value, i) => (
            <Placeholder key={`${value}-${i}`} type="text" />
          ))}
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className={curbsideClasses} sharp>
      {curbsidePickupFlag && (
        <CardContent>
          <h3 className={cx('store-hero-curbside__header')}>
            We&apos;re making shopping easier &amp; safer during this difficult time.
          </h3>
          <a href="/c/curbside_pickup">
            <Image
              src="//assets.thdstatic.com/images/v1/curbside.svg"
              alt="StoreHeroCurbside Image"
              title="StoreHeroCurbside Image"
              height={94}
              width={120}
            />
          </a>
          <span className={cx('store-hero-curbside__text')}>Curbside Pickup</span>
          <span className={cx('store-hero-curbside__text--small')}>
            Order online and we&apos;ll bring your items out to your car
          </span>
          <Button
            className={cx('store-hero-curbside__link')}
            data-testid="curbside-learn-more-button"
            link
            onClick={() => {
              redirectUser({ href: '/c/curbside_pickup' });
            }}
            tag="a"
          >
            <span>Learn more</span>
          </Button>
        </CardContent>
      )}
      {!curbsidePickupFlag && (
        <>
          <CardTitle title="Upcoming Workshops" />
          <CardContent>
            <Button
              className={cx('store-hero-curbside__link')}
              link
              onClick={() => {
                redirectUser({ href: `/workshop?storeid=${storeId}` });
              }}
              tag="a"
            >
              <span>All workshops at this Store</span>
            </Button>
          </CardContent>
        </>
      )}
    </Card>
  );
};

StoreHeroCurbside.propTypes = {
  className: string
};

StoreHeroCurbside.defaultProps = {
  className: null
};

StoreHeroCurbside.displayName = 'StoreHeroCurbside';

export { StoreHeroCurbside };
